import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Alert } from 'react-bootstrap';
import { actionCreators } from '../actions/globalAction';
import { Loader } from '../components/solar/Loader';
import { vorhersage } from '../components/objects/vorhersage';

class VorhersageClass extends Component {
    componentDidMount() {
        this.props.request(vorhersage["AktuelleVorhersageClass"]);
    }

    render() {
        let AktuelleVorhersageUI = this.props.AktuelleVorhersageUI || {};
        let show_Loader = AktuelleVorhersageUI.length == 0;
        let hasData = AktuelleVorhersageUI.length > 0 && AktuelleVorhersageUI.trim().length > 0;

        return (
            <div className="vorhersage-page">
                {/* Page header */}
                <div className="page-header-row mb-4">
                    <div className="d-flex align-items-center gap-3">
                        <div className="vorhersage-icon-circle">
                            <i className="bi bi-cloud-sun" />
                        </div>
                        <div>
                            <h2 className="mb-1">Vorhersage</h2>
                            <p className="text-muted mb-0 small">
                                Wetterprognose und Solardaten — PVGIS-Prognose
                            </p>
                        </div>
                    </div>
                </div>

                <Loader show={show_Loader} />

                {hasData ? (
                    <Card className="vorhersage-card mb-4">
                        <Card.Header>
                            <i className="bi bi-calendar2-week me-2" />
                            Kurzzeit-Prognose
                        </Card.Header>
                        <Card.Body>
                            <div
                                className="vorhersage-content"
                                dangerouslySetInnerHTML={{ __html: AktuelleVorhersageUI }}
                            />
                        </Card.Body>
                    </Card>
                ) : !show_Loader && (
                    <Alert variant="warning">
                        <i className="bi bi-exclamation-triangle me-2" />
                        Keine Prognosedaten verf&uglig;bar. Bitte sp&auml;ter erneut versuchen.
                    </Alert>
                )}

                {/* Info card about data source */}
                <Card className="mb-4">
                    <Card.Body>
                        <div className="d-flex align-items-start gap-3">
                            <i className="bi bi-info-circle text-primary fs-5" />
                            <div>
                                <h6 className="mb-1">Datenquelle</h6>
                                <p className="small mb-0 op-75">
                                    Die Wetterprognose basiert auf PVGIS-Daten der EU-Kommission (Joint Research Centre).
                                    Dargestellt werden Tageswerte f&uuml;r Temperatur, Niederschlag, Sonnenscheindauer,
                                    UV-Index und Globalstrahlung.
                                </p>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default connect(
    state => state.vorhersageReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(VorhersageClass);
